import gql from 'graphql-tag';

export const getTurnoverContacts = gql`
  query getTurnoverContacts($id: String) {
    getTurnoverContacts(id: $id) {
      id
      firstName
      lastName
    }
  }
`;
